import { assign, map } from 'lodash';
import { PersonType } from 'common/common/constants/person-type.enum';


/**
 * <fields>
 <field name="ChatPersonID" type="long" generateIfNull="true"/>
 <field name="ChatID" type="long"/>
 <field name="PersonID" type="long"/>
 <field name="PersonType" type="byte"/>
 <field name="Name" type="text"/>
 <field name="ImageUrl" type="text"/>
 <field name="IsTyping" type="byte"/>
 <field name="AccountID" type="long" useAccountIDIfNull="true"/>
 <field name="Created" type="created" allowsUpdates="false"/>
 <field name="Updated" type="updated"/>
 <field name="Deleted" type="datetime"/>
 </fields>
 * @param chatPerson
 * @constructor
 */


export class ChatPerson {
  public AccountID: string;
  public ChatID: string;
  public ChatPersonID: string;
  public Created: string;
  public Deleted: string;
  public ImageUrl: string;
  public IsTyping: number;
  public Name: string;
  public PersonID: string;
  public PersonType: PersonType;
  public Updated: string;

  static comparator(chat1, chat2) {
    return chat1.ChatPersonID === chat2.ChatPersonID;
  }

  static wrap(event) {
    return new ChatPerson(event.data);
  }

  static wrapAll(eventList) {
    return map(eventList, ChatPerson.wrap);
  }

  constructor(chatPerson) {
    assign(this, chatPerson);
  }

  isEquals(chatPerson) {
    return ChatPerson.comparator(this, chatPerson);
  }

  isAgent() {
    return this.PersonType === PersonType.Operator;
  }

  isVisitor() {
    return this.PersonType === PersonType.Visitor;
  }
}

export function factory() {
  return ChatPerson;
}
